const RENEW_URGENT_NEWS = 'renew_urgent_news';
const RENEW_NOTIFICATION_LIST = 'renew_notification_list';

module.exports = {
    renewUrgentNews: RENEW_URGENT_NEWS,
    renewNotificationList: RENEW_NOTIFICATION_LIST
};
